import { render, staticRenderFns } from "./ColorLabel.vue?vue&type=template&id=65181550&scoped=true"
import script from "./ColorLabel.vue?vue&type=script&lang=ts"
export * from "./ColorLabel.vue?vue&type=script&lang=ts"
import style0 from "./ColorLabel.vue?vue&type=style&index=0&id=65181550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65181550",
  null
  
)

export default component.exports